import { render, staticRenderFns } from "./VideoInputField.vue?vue&type=template&id=042b422a&scoped=true"
import script from "./VideoInputField.vue?vue&type=script&lang=ts"
export * from "./VideoInputField.vue?vue&type=script&lang=ts"
import style0 from "./VideoInputField.vue?vue&type=style&index=0&id=042b422a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042b422a",
  null
  
)

export default component.exports